// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Z2ErM","buttons":"Footer_buttons__W4hZw"};